(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-warranty-label"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-eu-warranty]').forEach(function (root) {
    if (root.dataset.euwInit) return;
    root.dataset.euwInit = '1';

    var htmlLang = String(document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
    var shopifyLang = '';
    if (window.Shopify && window.Shopify.locale) shopifyLang = String(window.Shopify.locale).toLowerCase().split('-')[0];
    var hostLang = String(location.hostname || '').split('.')[0].toLowerCase();
    var activeLocale = shopifyLang || htmlLang;
    if (htmlLang && root.getAttribute('data-src-' + htmlLang)) activeLocale = htmlLang;
    if (hostLang && root.getAttribute('data-src-' + hostLang)) activeLocale = hostLang;
    var localizedSrc = root.getAttribute('data-src-' + activeLocale);
    if (localizedSrc) {
      root.querySelectorAll('[data-euw-lightbox]').forEach(function (btn) {
        btn.setAttribute('data-euw-lightbox', localizedSrc);
        var picture = btn.querySelector('img');
        if (picture) picture.src = localizedSrc;
      });
    }

    var fallbackCopy = {
      de: ['Gesetzliche Gewährleistung', '2 Jahre · EU-Verbraucherrecht'],
      en: ['Legal guarantee', '2 years · EU consumer law'],
      fr: ["Garantie légale", "2 ans · Droit des consommateurs de l'UE"],
      nl: ['Wettelijke garantie', '2 jaar · EU-consumentenrecht'],
      it: ['Garanzia legale', "2 anni · Diritto dei consumatori dell'UE"],
      es: ['Garantía legal', '2 años · Derecho de los consumidores de la UE'],
      pl: ['Gwarancja prawna', '2 lata · Prawo konsumenta UE']
    };
    var blockedTitles = {
      'gesetzliche gewährleistung': true,
      'garanzie implicite': true
    };
    var card = root.querySelector('[data-euw-item]');
    var titleEl = card && card.querySelector('.euw__title');
    var subEl = card && card.querySelector('.euw__subtitle');
    function applyCopy() {
      var pair = fallbackCopy[activeLocale] || fallbackCopy.de;
      var customTitle = root.getAttribute('data-title-' + activeLocale) || '';
      var customSub = root.getAttribute('data-subtitle-' + activeLocale) || '';
      var title = customTitle;
      var sub = customSub;
      if (!title || blockedTitles[title.trim().toLowerCase()]) title = pair[0];
      if (!sub || sub.trim() === '2 Jahre · EU-Verbraucherrecht') sub = pair[1];
      if (titleEl && titleEl.textContent !== title) titleEl.textContent = title;
      if (subEl && subEl.textContent !== sub) subEl.textContent = sub;
    }
    if (activeLocale !== 'de') {
      applyCopy();
      if (titleEl) {
        var copyObserver = new MutationObserver(applyCopy);
        copyObserver.observe(titleEl, { childList: true, characterData: true, subtree: true });
        if (subEl) copyObserver.observe(subEl, { childList: true, characterData: true, subtree: true });
        setTimeout(function () { copyObserver.disconnect(); }, 10000);
      }
    }

    root.querySelectorAll('[data-euw-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var scrollX = window.scrollX;
        var scrollY = window.scrollY;
        var card = btn.closest('[data-euw-item]');
        var panel = card.querySelector('[data-euw-panel]');
        var open = card.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
        function keepPosition() {
          window.scrollTo(scrollX, scrollY);
        }
        keepPosition();
        requestAnimationFrame(keepPosition);
        setTimeout(keepPosition, 60);
      });
    });

    var modal = root.querySelector('[data-euw-lightbox-modal]');
    var modalImg = modal && modal.querySelector('.euw__lightbox-img');
    var closeBtn = modal && modal.querySelector('[data-euw-lightbox-close]');
    if (modal) document.body.appendChild(modal);

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      if (modalImg) modalImg.src = '';
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-euw-lightbox]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!modal || !modalImg) return;
        modalImg.src = btn.getAttribute('data-euw-lightbox');
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
